export const styles = {
  boxStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { lg: "860px", md: "780px", sm: "90%", xs: "95%" },
    bgcolor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
    p: { xs: 2.5, sm: 3.5 },
    maxHeight: "92vh",
    outline: "none",
    overflowY: "auto",
  },
};
